<script>
	// NPM Modules
	// Stores
	import MultiExpressGroupStore from '@/Stores/MultiExpressGroupStore.js';
	// Constants
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Prompt from '@/Components/Prompt.svelte';
	import Icon from '@/Components/Icon.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let parentMarket;
	export let first;
	export let last;

	let deleting = false;
	let promptDelete = false;

	function onDeleting() {
		promptDelete = true;
	}

	function onDelete() {
		deleting = true;
		MultiExpressGroupStore.deleteMultiExpressGroupParentMarket(parentMarket)
			.then(() => {
				notify({
					type: 'success',
					title: 'Multi Express Group',
					message: 'Multi Express Group Deleted',
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to delete the Multi Express Group',
					timeout: 5
				});
			})
			.finally(() => (deleting = false));
	}

	function shiftOrderUp() {
		MultiExpressGroupStore.changeMultiExpressGroupParentMarketOrder(
			parentMarket.multi_express_group_id,
			parentMarket.order,
			parentMarket.order - 1
		);
	}

	function shiftOrderDown() {
		MultiExpressGroupStore.changeMultiExpressGroupParentMarketOrder(
			parentMarket.multi_express_group_id,
			parentMarket.order,
			parentMarket.order + 1
		);
	}
</script>

<Prompt
	bind:open={promptDelete}
	title="Confirm delete"
	message="This can't be undone. Are you sure?"
	onConfirm={onDelete}
/>

<div class="px-1 bg-gray border">
	<div class="flex flex-row">
		<div class="flex-1">
			<div class="flex ml-20 mb-5">
				<div class="flex flex-row pt-1 border-gray-300 mt-2">
					<div class="flex flex-col">
						<button
							on:click={() => shiftOrderUp()}
							disabled={parentMarket.order === first}
							class:opacity-0={parentMarket.order === first}
						>
							<Icon name="up-arrow" classes="w-7 h-7" />
						</button>
						<span class="flex flex-row justify-center my-px">{parentMarket.order}</span>
						<button
							on:click={() => shiftOrderDown()}
							disabled={parentMarket.order === last}
							class:opacity-0={parentMarket.order === last}
						>
							<Icon name="down-arrow" classes="w-7 h-7" />
						</button>
					</div>
					<div class="w-80 text-sm flex flex-row items-center">
						<span class=""> {parentMarket.parent_market.name}</span>
					</div>

					<div class="w-1/4 text-center justify-center mt-5">
						<LoadingButton on:click={onDeleting} className="btn btn-primary-action" loading={deleting}>
							<Icon name="bin" classes="w-3 h-3" />
						</LoadingButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
